import { useTranslation } from 'react-i18next'

import generalStyles from '../CandidateDetailsContainer.module.scss'

import { CardDashboard, Flex, IllustratedMessage } from '@percent/lemonade'
import { CandidateReviewsCardProps } from './CandidateReviewsCard.types'
import { CandidateReview } from './candidateReview/CandidateReview'

export function CandidateReviewsCard({ reviews }: Readonly<CandidateReviewsCardProps>) {
  const { t } = useTranslation()

  const isReviewsEmpty = reviews.length === 0

  return (
    <Flex direction="column" data-testid="candidate-reviews-page" className={generalStyles.cardCtn}>
      {isReviewsEmpty ? (
        <CardDashboard data-testid="no-reviews-ctn">
          <IllustratedMessage
            title={t('grants.reviews.noReviews.title')}
            description={t('grants.reviews.noReviews.description')}
            illustration="no-grant-candidates"
          />
        </CardDashboard>
      ) : (
        <CardDashboard title={t('grants.reviews.title')} data-testid="reviews-details">
          {reviews.map(review => (
            <CandidateReview key={review.id} review={review} />
          ))}
        </CardDashboard>
      )}
    </Flex>
  )
}
